import { useEffect, useState } from "react";

interface GenericTabsProps {
    initialTab: number;
    currentTab?: number;
    tabs: {
        id: number,
        label: string,
        onClick: Function,
    }[];
}

const COMPONENT_CLASS = "c-generic-tabs";

const GenericTabs: React.FC<GenericTabsProps> = (props) => {
    const {
        initialTab,
        currentTab,
        tabs
    } = props;

    const [activeTab, setActiveTab] = useState(currentTab !== undefined ? currentTab : initialTab);

    useEffect(() => {
        if (currentTab !== undefined) {
            setActiveTab(currentTab);
        }
    }, [currentTab]);

    return (
        <div className={COMPONENT_CLASS}>
            {tabs.map((tab) => {
                return (
                    <div
                        key={tab.id}
                        className={`${COMPONENT_CLASS}__tab ${activeTab === tab.id ? "active" : ""}`}
                        onClick={() => {
                            setActiveTab(tab.id);
                            tab.onClick();
                        }}
                    >
                        {tab.label}
                    </div>
                )
            })}
        </div>
    );
}

export default GenericTabs;